import Link from "next/link"
import Image from "next/image"
import SocialMediaBar from "components/SocialMediaBar"

export default function Footer() {
  return (
    <footer className="bg-footer text-white py-10 px-5">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between md:items-center">
          <div className="flex flex-col gap-6">
            <div className="max-w-lg mx-auto">
              <Link href="https://federalnewsnetwork.com">
                <Image src="/assets/fnn-logo-hor.png" width="500" height="200" alt="Federal News Network" />
              </Link>
            </div>

            <div className="flex flex-col gap-6 md:flex-row">
              <div className="flex gap-2 justify-around max-w-xs mx-auto">
                <Link href="https://apps.apple.com/us/app/federal-news-network/id1018218419" target="_blank">
                  <Image src="/assets/apple.png" width="150" height="200" alt="Apple App Store" />
                </Link>
                <Link
                  href="https://play.google.com/store/apps/details?id=com.jacapps.wfed&;hl=en_US&pli=1"
                  target="_blank"
                >
                  <Image src="/assets/google.png" width="150" height="200" alt="Apple App Store" />
                </Link>
              </div>
              <SocialMediaBar type="primary" />
            </div>
          </div>

          <div className="py-6">
            <ul className="columns-2">
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/news-team" target="_blank">
                  News Team
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/careers" target="_blank">
                  Careers
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/contact-us" target="_blank">
                  Contact Us
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/sailthru-newsletters-signup" target="_blank">
                  Newsletters
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/publications" target="_blank">
                  Publications
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/radio-shows" target="_blank">
                  Podcasts
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/events" target="_blank">
                  Events
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/advertise" target="_blank">
                  Advertise
                </Link>
              </li>
              <li className="pb-4 md:pb-8 md:mr-24 text-button">
                <Link href="https://federalnewsnetwork.com/partners-events" target="_blank">
                  Partners
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6">
          <ul className="list-none text-center">
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link href="https://corporate.hubbardradio.com/terms-of-use/" target="_blank">
                Terms of Use
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link href="https://federalnewsnetwork.com/copyright-policy/" target="_blank">
                Copyright/Usage Policy
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link href="https://corporate.hubbardradio.com/dmca-notice/" target="_blank">
                DMCA Notice
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link href="https://corporate.hubbardradio.com/privacy-policy/" target="_blank">
                Privacy Policy
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link href="https://federalnewsnetwork.com/comment-policy/" target="_blank">
                Comment Policy
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link
                href="https://federalnewsnetwork.com/wp-content/uploads/2024/05/FCC-EEO-Public-File-Report-Hubbard-Radio-DC-6_1_2024.pdf"
                target="_blank"
              >
                EEO Report
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link
                href="https://federalnewsnetwork.com/wfed-1500-am-online-fcc-public-inspection-files/"
                target="_blank"
              >
                FCC Online Public Inspection File
              </Link>
            </li>
            <li className="pb-4 text-button inline-block pr-8 ">
              <Link href="https://federalnewsnetwork.com/fcc-applications/" target="_blank">
                FCC Applications
              </Link>
            </li>
          </ul>
        </div>
        <p className="md:text-center">
          Copyright {new Date().getFullYear()} Hubbard Radio Washington DC, LLC. All rights reserved. This website is
          not intended for users located within the European Economic Area.
        </p>
      </div>
    </footer>
  )
}
